export default __webpack_public_path__ + "4b3889851acec940012cf1ccd8ead411.png";